
const angular = require('angular')

angular.module('clientDashboardApp.admin').factory('credentialService', function($http, providerService, userService) {

  return {

    listProviders: function() {
      return userService.currentUser().then(user => {
        return providerService.validProvidersAndKeyedById("all-" + user.username, "REVIEW_RESPONSES")
      })
    },

    searchCredentials: function(opts) {
      return $http.get("/v5/credentials/search", {
        params: opts
      }).then(response => {
        return response.data.results
      })
    },

    listingsForCredential: function({credentialId, offset, limit}) {
      return $http.get(`/v5/credentials/${credentialId}/listings`, {
        params: {offset, limit}
      }).then(response => {
        return response.data.listings
      })
    },

    countCredentials: function(opts) {
      return $http.get("/v5/credentials/count", {
        params: opts
      }).then(response => {
        return response.data.count
      })
    },

    deleteCredential: function(credentialId) {
      $http.delete(`/v5/credentials/${credentialId}/delete`)
    },

    updateRemoteResourceList: function(credentialId) {
      return $http.post(`/v5/credentials/${credentialId}/updateRemoteResourceList`)
    },

    saveCredential: function(provider, username, password) {
      return $http.post("/v5/credentials/save", {
        provider: provider,
        username: username,
        password: password
      }).then(response => {
        return response.data
      })
    },

    listingsMissingCredentials: function(provider) {
      return $http.get("/v5/listingsWithoutCredentials/" + provider).then(x => x.data)
    }
  }

})
